import { Descriptions, Row } from "antd";
import getAtribute from "../../../utils/getAtribute";
import phoneMask from "../../../utils/getPhoneMask";

export function DetailsAddress({ entidade }) {
  const orgaos = [
    "SSPDS",
    "PCCE",
    "PMCE",
    "CBMCE",
    "PEFOCE",
    "SUPESP",
    "AESP",
  ];

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Endereço</div>
      </Row>

      <Descriptions>
        <Descriptions.Item label="CEP">
          {getAtribute(entidade, "cep")}
        </Descriptions.Item>
        <Descriptions.Item label="Endereço">
          {getAtribute(entidade, "endereco")}
        </Descriptions.Item>
        <Descriptions.Item label="Numero">
          {getAtribute(entidade, "numero")}
        </Descriptions.Item>
        <Descriptions.Item label="Complemento">
          {getAtribute(entidade, "complemento")}
        </Descriptions.Item>
        <Descriptions.Item label="Bairro">
          {getAtribute(entidade, "bairro")}
        </Descriptions.Item>
        <Descriptions.Item label="Cidade">
          {getAtribute(entidade, "cidade")}
        </Descriptions.Item>
        <Descriptions.Item label="Órgão lotação">
          { orgaos.indexOf(entidade.orgao) > -1 ? getAtribute(entidade, "orgao") : `${getAtribute(entidade, "orgao")} (EXTERNO)` }
        </Descriptions.Item>
        <Descriptions.Item label="Unidade Lotação">
          {getAtribute(entidade, "unidadeLotacao")}
        </Descriptions.Item>
        <Descriptions.Item label="Telefone lotação">
          {phoneMask(getAtribute(entidade, "telefoneLotacao"))}
        </Descriptions.Item>
        <Descriptions.Item label="Cargo">
          {getAtribute(entidade, "cargo")}
        </Descriptions.Item>
        <Descriptions.Item label="Função">
          {getAtribute(entidade, "funcao")}
        </Descriptions.Item>
        <Descriptions.Item label="Cargo">
          {getAtribute(entidade, "cargo")}
        </Descriptions.Item>
      </Descriptions>
      <div className="divider" />
    </>
  );
}
